<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Clientes ({{clientes.length}}/{{clientesTodos.length}})</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="content">
    <ion-searchbar placeholder="Buscar" :value="filtro" v-on:ionChange="filtrar($event.detail.value)" debounce="500" />
    <ion-list>
      <ion-item-sliding v-for=" u in clientes" :key="u._id">
        <ion-item v-on:click="ver(u._id)">
          <ion-note slot="start">
            <i class="icon ion-ios-person"></i>
          </ion-note>
          <ion-label text-wrap>
            <h2>{{u.nombre}}</h2>
            <p>{{u.representante}}</p>
          </ion-label>
        </ion-item>
        <ion-item-options slot="end">
          <ion-item-option color="danger" @click="eliminar(u)" v-if="yo.permiso_eliminaClientes">
            <i class="icon ion-ios-trash"></i>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="ver('0')">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'CatalogoClientes',
  data() {
    return {
      cargando: false,
      yo: Api.fetchLocal('cmms.yo') || {},
      limiteClientes: 50,
      filtro: '',
      clientesTodos: [],
      clientes: [{
        nombre: 'IMSS HGZ No. 2',
        rfc: 'IMS421231I45',
        email: 'conservacionhgz2@hotmail.com'
      }, {
        nombre: 'Nuestra Señora de los Ángeles',
        rfc: 'AAA010101AAA',
        email: 'compras@nuestraseñoradelosangeles.com'
      }]
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    ver(id) {
      this.$router.push('/catalogos/clientes/' + id)
    },
    async obtener() {
      this.cargando = true
      let clientes = (await Api.get('cliente'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
        .filter(c => c.nombre && c.nombre != '')
      this.clientes = []
      this.clientesTodos = clientes
      console.log("clientesTodos", this.clientesTodos)
      this.filtrar('')
      this.cargando = false
    },
    filtrar(str = '') {
      str = (str || '').toUpperCase()
      this.filtro = str
      if (str == '')
        this.clientes = JSON.parse(JSON.stringify(this.clientesTodos))
        .splice(0, this.limiteClientes)
      else {
        this.clientes = this.clientesTodos
          .filter(c => {
            let strMaestra = ''
            for (let prop of ['nombre', 'alias', 'email', 'representante'])
              strMaestra += (c[prop] || '').toUpperCase()
            console.log("F?", strMaestra, str)
            return strMaestra.indexOf(str) >= 0
          })
          .splice(0, this.limiteClientes)
      }
    },
    async eliminar(u) {
      if (true == confirm('Desea eliminar este cliente?')) {
        await Api.delete('cliente', u._id)
        toast("Eliminado")
        await Api.wait()
        this.obtener()
      }
    }
  },
  async mounted() {
    this.obtener()
    if (false) {
      await Api.wait(2000)
      for (let cl of this.clientesTodos)
        if (cl.importado && cl.importado > 0)
          await Api.delete('cliente', cl._id)
    }
  }
}
</script>
